import { render, staticRenderFns } from "./ForgotPasswordV2.vue?vue&type=template&id=24516d12&scoped=true"
import script from "./ForgotPasswordV2.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordV2.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordV2.vue?vue&type=style&index=0&id=24516d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24516d12",
  null
  
)

export default component.exports